import React, { useEffect } from "react";
import { CategoryTabs } from "../welcome/CategoryTabs";
import { ActionCard } from "../welcome/ActionCard";
import useQuickActionsStore from "../../store/quickActionsStore";
import { CategoryType } from "../welcome/types";
import { trackEvent } from "../../services/analyticsService";
import { logDebug } from "../../utils/logging";
import styles from "../welcome/QuickActionGrid.module.css";
import useGuidedFlowStore from "../../store/guidedFlowStore";
import { useUIStore } from "../../store/uiStore";

const CATEGORIES: CategoryType[] = ["Toate", "Copywriting", "Document", "Altele"];

const PromptsPage: React.FC = () => {
  const navigate = useUIStore((s) => s.navigate);
  const {
    templates,
    filteredTemplates,
    selectedCategory,
    isLoading,
    error,
    loadTemplates,
    setSelectedCategory,
    setSelectedCardType,
  } = useQuickActionsStore();

  // Load ALL templates once; no welcome cards
  useEffect(() => {
    logDebug("[PromptsPage] Loading all templates (no card_type filter)");
    setSelectedCardType("creaza_draft"); // default; but we will not filter by card_type
    loadTemplates(undefined, selectedCategory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCategoryChange = (category: CategoryType) => {
    setSelectedCategory(category);
    // Re-filter using store logic (already updates filteredTemplates)
    trackEvent("prompts_category_changed", { category });
  };

  const handleTemplateSelect = (template: ReturnType<typeof useQuickActionsStore.getState>["templates"][number]) => {
    logDebug("[PromptsPage] Template selected", template.template_id);
    // Start guided flow and route to chat view
    useGuidedFlowStore.getState().startFlow(template);
    navigate("chat");
    trackEvent("prompts_template_selected", {
      template_id: template.template_id,
      category: template.category,
    });
  };

  return (
    <div style={{ padding: 16 }}>
      <h1 style={{ marginTop: 0 }}>Prompturi</h1>

      {error && (
        <div className={styles.errorState} style={{ marginBottom: 12 }}>
          <p className={styles.errorMessage}>Nu am putut încărca șabloanele. Reîncearcă.</p>
          <button className={styles.retryButton} onClick={() => loadTemplates(undefined, selectedCategory)}>
            Reîncearcă
          </button>
        </div>
      )}

      {/* Category filter */}
      <CategoryTabs
        categories={CATEGORIES}
        selectedCategory={selectedCategory}
        onCategoryChange={handleCategoryChange}
      />

      <div className={styles.templateGrid} role="list" aria-label="Lista șabloanelor disponibile">
        {isLoading ? (
          <div className={styles.loadingState}>
            <p>Se încarcă șabloanele...</p>
          </div>
        ) : (
          (filteredTemplates.length > 0 ? filteredTemplates : templates).map((template) => (
            <ActionCard key={template.template_id} template={template} onClick={() => handleTemplateSelect(template)} />
          ))
        )}
      </div>
    </div>
  );
};

export default PromptsPage;
